import { render, staticRenderFns } from "./new.submission.page.vue?vue&type=template&id=b7be2db8&"
import script from "./new.submission.page.vue?vue&type=script&lang=js&"
export * from "./new.submission.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports